// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';
import moment, { isMoment } from 'moment';
import Header from './Header';
import Day from './Day';
import DayGrid from './DayGrid';
import { calendarMonthDates, isSameMonth, isBeforeToday, isOneOfDates } from 'utils/date-utils';

const StyledCalendar = styled.div`
  background-color: white;
  border-radius: 2px;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 320px;
  z-index: 1;
  box-shadow: 0 1px 5px 0 rgba(55,66,74,0.18);
  border: 1px solid #CED5D8;
  &.full-width {
    max-width: 100%;
  }
`;

class Calendar extends Component {

  static propTypes = {
    onMonthChange: PropTypes.func
  };

  static defaultProps = {
    HeaderComponent: Header,
    DayComponent: Day
  };

  state = {}

  constructor(props:Object) {
    super(props);

    const currentMonth:moment = isMoment(props.currentMonth) && props.currentMonth.isValid() ? props.currentMonth : moment();
    this.state = {
      currentMonth,
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.currentMonth !== nextProps.currentMonth) {
      const currentMonth:moment = isMoment(nextProps.currentMonth) && nextProps.currentMonth.isValid() ? nextProps.currentMonth : moment();
      this.setState({
        currentMonth
      })
    }
  }

  triggerMonthChange = () => {
    if(this.props.onMonthChange) {
      this.props.onMonthChange(this.state.currentMonth);
    }
  }

  handlePrev = () => {
    const currentMonth = this.state.currentMonth.clone().subtract(1, 'month');
    this.setState({
      currentMonth
    }, this.triggerMonthChange);
  }

  handleNext = () => {
    const currentMonth = this.state.currentMonth.clone().add(1, 'month');
    this.setState({
      currentMonth
    }, this.triggerMonthChange);
  }

  render() {
    const visibleDates = calendarMonthDates(this.state.currentMonth);
    const {className, DayComponent, HeaderComponent} = this.props;
    const onClick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
    }

    return (
      <StyledCalendar className={className} onClick={onClick}>
        <HeaderComponent
          handlePrev={this.handlePrev}
          handleNext={this.handleNext}
          currentMonth={this.state.currentMonth}
          showDateRanges={this.props.showHeaderDateRanges}
        />
        <DayGrid>
          {visibleDates.map((date, i) => {
            return (
              <DayComponent
                key={i}
                date={date}
                disabled={!isSameMonth(date, this.state.currentMonth) || isBeforeToday(date)}
                blocked={isOneOfDates(date, this.props.blockedDates)}
              />
            )})
          }
        </DayGrid>
      </StyledCalendar>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/Calendar.js